export const navItems = [
  { label: "料金目安", href: "#price" },
  { label: "ご依頼の流れ", href: "#flow" },
  { label: "サービス", href: "#service" },
  { label: "片付け＋リフォーム", href: "#onestop" },
  { label: "リフォーム", href: "#cases" },
  { label: "対応エリア", href: "#area" },
  { label: "会社紹介", href: "#company" },
  { label: "よくある質問", href: "#faq" },
];

export const heroBadges = [
  { icon: "ri-price-tag-3-line", main: "見積もり", sub: "無料" },
  { icon: "ri-map-pin-2-line", main: "春日部市", sub: "地域密着" },
  { icon: "ri-hammer-line", main: "片付け＋", sub: "リフォーム" },
  { icon: "ri-shield-check-line", main: "建設業許可", sub: "取得" },
];

export const trustPoints = [
  {
    icon: "ri-home-heart-line",
    title: "春日部市の建設会社が運営",
    text: "屋根・塗装を中心に住宅リフォームを行う株式会社小林建設が運営しています。",
  },
  {
    icon: "ri-hand-coin-line",
    title: "見積もり無料",
    text: "出張費・お見積もりは無料。見積内容から変更がなければ原則追加料金なし。",
  },
  {
    icon: "ri-route-line",
    title: "片付けからリフォームまで",
    text: "不用品回収・遺品整理のあとの原状回復やリフォームまで一社で相談できます。",
  },
  {
    icon: "ri-map-pin-time-line",
    title: "地域密着でスピーディー",
    text: "会社から近い地域のお客様を大切に、素早い対応を心がけています。",
  },
];